import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { Comments } from '../Models';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslationKeys } from 'ph-bhp-localization';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-ph-bhp-observe-protocol-comments',
  templateUrl: './ph-bhp-observe-protocol-comments.component.html',
  styleUrls: ['./ph-bhp-observe-protocol-comments.component.css']
})

export class PhBhpObserveProtocolCommentsComponent implements OnInit {
  @Input() isCollapsed = true;
  quickCommentIndex;
  @Input() isEdit = true;
  @Input() numberToName;
  @Input() stepNumber;
  @Input() sopid;
  @Output() childData = new EventEmitter();
  @ViewChild('userCommentFrom') userCommentFrom;
  @ViewChild('delete') delete: TemplateRef<any>;
  @Input() userData
  @Input() institutions
  stepName: String;
  userComment: string;
  @Input() comments: Array<Comments> = [];
  @Input() observationId = 0;
  backupComments: Array<Comments> = [];
  sopObserveCommentsMaxLength = 500;
  newModalRef: BsModalRef;
  predefinedComments: Array<any>;// = ["jewellery / wrist watch", "artificial finger nails / nail varnish", "Hand disinfection executed incorrectly", "Skin antisepsis executed incorrectly"];
  removeIndex: number;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  @Input() isOverviewIndividual = false;

  constructor(public service: PhBhpFeaturePackageSopobservationService, private layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public config: AppConfig) { }

  ngOnInit() {

  }

  ngOnChanges() {
    var userData;
    if (!this.userData) {
      userData = this.config.userData;
    } else {
      userData = this.userData;
    }

    this.service.getInstitutionGroupIdById(this.layoutService.institutionID).subscribe((groupId) => {
      var institutionGroupId = "0"
      if (groupId != 0) {
        institutionGroupId = `${groupId},${this.layoutService.institutionID}`;
      }

      this.service.getPredefinedCommentsForObservation(userData.country, institutionGroupId, this.layoutService.institutionID).subscribe((comments) => {
        this.predefinedComments = [];
        comments.forEach(comment => {
          switch (comment.commentName) {
            case 'jewellery / wrist watch':
              comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH');
              break;
            case 'artificial finger nails / nail varnish':
              comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH');
              break;
            case 'Hand disinfection executed incorrectly':
              comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED');
              break;
            case 'Skin antisepsis executed incorrectly':
              comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED');
              break;
            case 'Process interrupted':
              comment.commentName = this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED');
              break;
          }

          if (comment.packages?.includes("1")) {
            this.predefinedComments.push(comment);
          }
        });
      });

      this.comments.forEach(comment => {
        var freeTextComment = comment.freeTextComment;
        var textCommentKey = this.layoutService.getTranslationKey(freeTextComment);
        if (textCommentKey) {
          comment.freeTextComment = '';
        } else {
          comment.freeTextComment = freeTextComment;
        }
      });
    });
  }

  isCommentSelected(predefinedComment, sopComment) {
    return sopComment.predefineCommentID == predefinedComment.predefinedCommentID;
  }

  selectComment(predefinedComment, sopComment) {
    if (sopComment.predefineCommentID == predefinedComment.predefinedCommentID) {
      sopComment.predefineCommentID = 0;
      sopComment.commentType = 0;
    } else {
      sopComment.predefineCommentID = predefinedComment.predefinedCommentID;
      sopComment.commentType = 1;
    }
  }

  closeComments() {
    this.childData.emit({ key: "close" })
  }

  startEditingComments() {
    this.isEdit = true;
    this.backupComments = this.comments;
  }

  getTextComment(comment) {
    if (!this.predefinedComments) return '';
    if (comment.commentType == 0) {
      return comment.freeTextComment;
    } else {
      var commentTexts = [];
      var predefinedComment = this.predefinedComments.find(x => x.predefinedCommentID == comment.predefineCommentID);
      commentTexts.push(predefinedComment.commentName);
      if (comment.freeTextComment && comment.freeTextComment.length > 0) {
        commentTexts.push(comment.freeTextComment);
      }

      return commentTexts.join(', ');
    }
  }

  cancelEditingComments() {
    this.isEdit = false;
    this.comments = this.backupComments;
  }

  saveEditingComments() {
    this.layoutService.showLoader = true;
    var userId = this.config.userData.userId;
    this.service.updateObservationComments(this.observationId, userId, { comments: this.comments, commentsData: JSON.stringify(this.comments) }).subscribe((res) => {
      this.layoutService.showInfo(this.layoutService.translateText('SOP_OBSERVATION.COMMENTS_UPDATED_SUCCESSFULLY'));
      this.layoutService.showLoader = false;
      this.isEdit = false;
      this.backupComments = this.comments;
    });
  }
}
